document.addEventListener('turbolinks:load', () => {
    // Store to SessionStorage
    window.storeCookie = function(cookieName, checkedItems) {
        let newCookie = cookieName + '=' + checkedItems.join(',');
        let date = new Date();
        date.setTime( date.getTime() + ( 24 * 60 * 60 * 1000 ));
        document.cookie = newCookie + ';path=/;expires=' + date.toUTCString() + ';max-age=86400';
    }

    // Set the checked Checkboxes
    window.setCheckedCheckboxes = function(jsonData, checkedItems) {
        if (checkedItems) {
            checkedItems.forEach( function( crop ) {
                const result = jsonData.find((u) => u.id === crop );
                if (result){
                    result.state = {selected: 'true'};
                }
            });
        }
        return jsonData;
    }
})